var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.el,{tag:"component",staticClass:"bg-white shadow rounded-lg",class:{
    'hover:shadow-lg cursor-pointer focus:ring-primary-2': _vm.clickable,
    'p-4 md:px-6': _vm.spacing,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }